module.exports = __webpack_public_path__ + "static/media/point-50.a7e1fecb.png";